var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolLoneWorker01 = function SvgSolLoneWorker01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_lone_worker-01_svg2__a",
    x1: 50.25,
    x2: 119.97,
    y1: 148.14,
    y2: 67.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_lone_worker-01_svg2__a",
    id: "sol_lone_worker-01_svg2__b",
    x1: 33.75,
    x2: 145.48,
    y1: 190.49,
    y2: 61.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_lone_worker-01_svg2__a",
    id: "sol_lone_worker-01_svg2__c",
    x1: 145.82,
    x2: 162.36,
    y1: 181.92,
    y2: 162.88
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M146.74 79.12c-1.26-21.11-16.35-38.85-37.09-43.45-1.05-2.26-3.24-3.78-5.79-3.78h-8.95c-2.54 0-4.74 1.52-5.79 3.79-20.73 4.61-35.81 22.36-37.07 43.45-4.4.74-7.77 4.55-7.77 9.15 0 2.46.98 4.69 2.54 6.36-1.45 1.61-2.36 3.71-2.36 6.03v3.85c0 6.55 5.16 11.59 12.81 12.83 3.29 14.18 16.17 28.96 31.06 34.49 4.06 1.5 7.57 2.19 11.05 2.19s6.99-.7 11.05-2.2c14.9-5.53 27.78-20.31 31.07-34.49 7.64-1.24 12.8-6.28 12.8-12.82v-3.85c0-2.32-.9-4.42-2.35-6.02 1.57-1.67 2.55-3.9 2.55-6.37 0-4.61-3.37-8.42-7.77-9.15Zm-6-.16h-26.97l-3.15-36.91c16.79 4.72 28.86 19.47 30.11 36.91ZM94.92 37.88h8.95c.27 0 .42.4.45.69l3.44 40.4H91l3.47-40.4c.03-.33.21-.69.45-.69m-6.77 4.18-3.17 36.91H58.07c1.25-17.43 13.32-32.18 30.09-36.91Zm-37.68 62.45v-3.85c0-1.69 1.4-3.07 3.13-3.07h2.84v12.98c0 .15.02.31.03.46-3.33-.98-6-3.12-6-6.52m57.89 41.69c-6.74 2.49-11.2 2.49-17.93 0-14.91-5.53-27.99-22.19-27.99-35.64V97.58H93.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H53.59a3.316 3.316 0 0 1 0-6.63h91.61c1.83 0 3.31 1.49 3.31 3.31s-1.49 3.32-3.31 3.32h-38.27c-1.66 0-3 1.34-3 3s1.34 3 3 3h29.42v12.98c0 13.45-13.08 30.1-27.99 35.63Zm39.95-41.69c0 3.39-2.67 5.54-5.99 6.51 0-.15.03-.3.03-.45V97.59h2.86c1.71 0 3.11 1.38 3.11 3.07v3.85Z",
    style: {
      fill: "url(#sol_lone_worker-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5 141.08c1.59-2.59 3.05-5.08 4.21-7.22 3.14-5.87 5.75-11.18 7.98-16.22a2.99 2.99 0 0 0-1.53-3.95c-1.52-.67-3.29.01-3.95 1.53-2.17 4.9-4.72 10.08-7.78 15.81-1.57 2.91-3.69 6.46-6.03 10.11-14.56 1.83-25.87 14.26-25.87 29.31 0 1.27.11 2.51.26 3.73-10.95 11.37-20.41 17.38-27.38 17.38-18.89 0-49.44-42.71-59-60.52-15.18-28.29-20.79-49.64-19.99-76.16l.03-.98c.08-2.59.15-5.03.56-5.51.51-.59 3.55-1.23 5.99-1.75C50.42 41.7 75.56 27.73 95.99 8.33c3.27-3.1 3.59-3.1 6.86 0 20.41 19.4 45.55 33.37 68.98 38.32 2.44.52 5.48 1.16 6 1.75.42.48.49 2.93.56 5.51l.03.97c.51 17.19-1.83 32.51-7.36 48.21a2.995 2.995 0 0 0 5.65 1.99c5.79-16.42 8.24-32.43 7.7-50.39l-.03-.97c-.28-9.54-1.44-10.87-11.32-12.96-22.04-4.66-46.75-18.41-66.09-36.8-5.58-5.29-9.54-5.29-15.12 0-19.35 18.39-44.06 32.14-66.1 36.8-9.87 2.08-11.03 3.42-11.31 12.96l-.03.97c-.82 27.31 5.18 50.25 20.7 79.17 6.78 12.64 39.54 63.68 64.28 63.68 8.13 0 17.91-5.59 29.09-16.59 4.26 11.11 15.01 19.04 27.6 19.04 16.3 0 29.56-13.26 29.56-29.56 0-15.15-11.46-27.66-26.16-29.35ZM156.09 194c-13 0-23.58-10.57-23.58-23.57s10.58-23.57 23.58-23.57 23.57 10.57 23.57 23.57S169.09 194 156.09 194",
    style: {
      fill: "url(#sol_lone_worker-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.97 162.45-11.68 12.06-5.83-4.29c-1.33-.98-3.21-.7-4.19.64-.98 1.33-.69 3.21.64 4.19l7.94 5.84c.53.39 1.15.58 1.78.58.79 0 1.57-.31 2.15-.91l13.5-13.95a3 3 0 0 0-.07-4.24 3 3 0 0 0-4.24.07Z",
    style: {
      fill: "url(#sol_lone_worker-01_svg2__c)"
    }
  }));
};
export default SvgSolLoneWorker01;